import React from 'react';
import Iframe from 'react-iframe';
import Time from './timer'
export default class IframeComponent extends React.Component {
  render() {
    return (
        <div>
        {/* <Routes checkvalue="true"/> */}
        <Time webname={this.props.webname}/>
       <Iframe url={this.props.name}
            position="absolute"
            width="100%"
            id="myId"
            className="myClassname"
            height="250%"
            styles={{height: "55px"}}/>
    
  </div>
    )
  }
}
